import Button from '../button';

type SearchProps = Readonly<{
  searchPlaceHolder: string;
  searchCta: string;
  searchQuery: string;
  handleSearch: (e: React.FormEvent) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}>;

export function Search({
  handleSearch,
  searchPlaceHolder,
  searchCta,
  searchQuery,
  onChange,
}: SearchProps) {
  return (
    <form className="search-form" onSubmit={handleSearch}>
      <input
        className="search-form__input"
        type="text"
        placeholder={searchPlaceHolder}
        value={searchQuery}
        onChange={onChange}
      />
      <i className="icon-search search-form__icon"></i>
      <Button content={searchCta} className="button-primary" type="submit" />
    </form>
  );
}

export function InlineSearch({
  handleSearch,
  searchCta,
  searchPlaceHolder,
  searchQuery,
  onChange,
}: SearchProps) {
  return (
    <div className="filters__search-wrapper">
      <form onSubmit={handleSearch}>
        <input
          className="filters__search"
          type="text"
          placeholder={searchPlaceHolder}
          value={searchQuery}
          onChange={onChange}
        />
        <button onClick={handleSearch} type="button" title={searchCta}>
          <i className="icon-search" />
        </button>
      </form>
    </div>
  );
}

export default Search;
